import {css, useTheme} from '@mui/material';
import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import hospitalizationDepartmentIcon from 'src/assets/icons/hospitalizationDepartment.svg';
import {GetStylesFunction} from 'src/js/common/types';

type Props = any;

export const DlMuiHospitalizationDepartmentIcon: React.FC<Props> = (props) => {
  const theme = useTheme();
  const styles = getStyles({theme});

  return (
    <SvgIcon
      css={styles.userIcon}
      component={hospitalizationDepartmentIcon}
      inheritViewBox
      {...props}
    />
  );
};

DlMuiHospitalizationDepartmentIcon.displayName = 'DlMuiHospitalizationDepartmentIcon';

const getStyles: GetStylesFunction = (options) => ({
  userIcon: css`
      width: 24px;
      height: 24px;
  `
});
